import { makeVar } from "@apollo/client";

export const networkError = makeVar(false);
